import { ReactElement, useMemo, useCallback } from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus as AddManualIcon,
  faFile as ImportFromFileIcon,
  faPlug as ImportFromIntegrationIcon,
  faWarehouse as ImportFromAssociatedCompany,
} from '@fortawesome/free-solid-svg-icons';

import {
  useAppSelector,
  useTypePartnerCompany,
  useEnabledCrossCompany,
} from '~hooks/index';
import { selectAuth } from '~store/slices/auth';
import { isOnlyCreatorOrder } from '~utils/user';

import { AddOrdersActionsMenuProps } from './types';
import { AddOrdersActionsMenuContainer } from './styles';

const AddOrdersActionsMenu = ({
  anchorEl,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'center',
  },
  open,
  onClose,
  onManual,
  onImportFromFile,
  onImportFromIntegration,
  onImportFromAssociatedCompany,
}: AddOrdersActionsMenuProps): ReactElement => {
  const { user } = useAppSelector(selectAuth);
  const { isCarrier } = useTypePartnerCompany();
  const { isEnabledCrossCompany } = useEnabledCrossCompany();

  const isUserOnlyCreatorOrder = useMemo(
    () => isOnlyCreatorOrder(user),
    [user],
  );

  const handleClickItem = useCallback(
    (callback: () => void) => {
      callback();
      onClose?.({}, 'backdropClick');
    },
    [onClose],
  );

  return (
    <AddOrdersActionsMenuContainer
      id="add-orders-actions-menu"
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
      elevation={0}
    >
      <MenuItem onClick={() => handleClickItem(onManual)}>
        <ListItemIcon>
          <FontAwesomeIcon icon={AddManualIcon} />
        </ListItemIcon>

        <ListItemText primary="Manualmente" />
      </MenuItem>

      <MenuItem onClick={() => handleClickItem(onImportFromFile)}>
        <ListItemIcon>
          <FontAwesomeIcon icon={ImportFromFileIcon} />
        </ListItemIcon>

        <ListItemText primary="Desde archivo" />
      </MenuItem>

      {!isUserOnlyCreatorOrder && (
        <MenuItem onClick={() => handleClickItem(onImportFromIntegration)}>
          <ListItemIcon>
            <FontAwesomeIcon icon={ImportFromIntegrationIcon} />
          </ListItemIcon>

          <ListItemText primary="Desde tiendas" />
        </MenuItem>
      )}

      {isCarrier && isEnabledCrossCompany && !isUserOnlyCreatorOrder && (
        <MenuItem
          onClick={() => handleClickItem(onImportFromAssociatedCompany)}
        >
          <ListItemIcon>
            <FontAwesomeIcon icon={ImportFromAssociatedCompany} />
          </ListItemIcon>

          <ListItemText primary="Recepcionar pedidos" />
        </MenuItem>
      )}
    </AddOrdersActionsMenuContainer>
  );
};

export default AddOrdersActionsMenu;
